import { useMe } from "components/use-hooks";
import { canCreateUsers } from "../helpers/user-access-helper";


const useCanCreateUsers = () => {

    const currentUser = useMe();

    return canCreateUsers(currentUser?.me);
};

export default useCanCreateUsers;
